import styles from "./accountDeletion.module.scss";
import { AccountDeletionForm } from "./AccountDeletionForm";

export const AccountDeletionPage = () => {
  const year = new Date().getFullYear();

  return (
    <main className={styles.page}>
      <article className={styles.card}>
        <header>
          <h1 className={styles.title}>
            Request account deletion — D.O.S. Cleaning
          </h1>
        </header>

        <p className={styles.lead}>
          You can request deletion of your D.O.S. Cleaning account and
          associated data from this page. If you still have the app installed,
          you can also delete your account directly from <strong>Profile →
          Delete Account</strong>.
        </p>

        <div className={styles.body}>
          <p className={styles.sectionHeading}>What we delete</p>
          <ul className={styles.list}>
            <li>Profile (name, email, phone, addresses)</li>
            <li>Saved payment methods</li>
            <li>Chat history and notifications</li>
            <li>Service request history (customer accounts)</li>
            <li>Employee timesheets older than retention window (employee accounts)</li>
          </ul>

          <p className={styles.sectionHeading}>What we retain</p>
          <ul className={styles.list}>
            <li>
              Invoices, payment records, and job records — retained 7 years
              for tax/legal compliance
            </li>
            <li>Anonymized analytics data</li>
          </ul>

          <p>We process deletion requests within 30 days.</p>
        </div>

        <AccountDeletionForm />

        <p className={styles.footer}>
          Questions? Email{" "}
          <a href="mailto:dfoster@daigleclean.com">dfoster@daigleclean.com</a>.
          <br />© {year} D.O.S. Cleaning
        </p>
      </article>
    </main>
  );
};
